<template>
  <template v-if="voyage">
    <div class="voyage-header">
      <div
        class="voyage-header__img"
        :style="{
          backgroundImage: `url(${voyage.cover_id?.lg || 'https://placehold.co/1920x1080'})`,
        }"
      />
    </div>

    <div class="voyage">
      <section class="voyage__content">
        <div style="display: flex">
          <LangRouterLink :to="{ name: 'voyages' }" class="button -light">
            <div class="button__icon -rotate">
              <Icon id="arrow" />
            </div>
            {{ $t('trip.goBack') }}
          </LangRouterLink>
        </div>
        <h1 class="voyage__title">{{ voyage.name }}</h1>
        <div v-html="voyage.description" class="wysiwyg voyage__wysiwyg" />
        <AdBanner :ads="ads" no-section />
        <template v-if="voyage.itinerary_description">
          <h3 class="voyage__subtitle">{{ $t('trip.description') }}</h3>
          <div v-html="voyage.itinerary_description" class="wysiwyg" />
        </template>
      </section>

      <section class="voyage-aside">
        <aside class="voyage-aside__card">
          <div class="voyage-aside__content">
            <div class="voyage-aside__type">
              <Icon :id="voyage.type === 'bus' ? 'autobus' : 'avion'" />
              <span>{{
                voyage.type === 'bus' ? $t('trips.type.bus') : $t('trips.type.plane')
              }}</span>
            </div>
            <div class="voyage-aside__row">
              <Icon id="geo" />
              <b>{{ $t('trip.destination') }} - </b> {{ voyage.city || voyage.name }}
            </div>
            <div class="voyage-aside__row">
              <Icon id="date" />
              <b>{{ $t('trip.days') }} - </b> {{ voyage.nb_days }}
            </div>
            <div class="voyage-aside__row">
              <Icon id="eat" />
              <b>{{ $t('trip.meals') }} - </b> {{ voyage.nb_meals }}
            </div>
            <div class="voyage-aside__options" v-if="voyage.options?.length">
              <b>{{ $t('trip.options') }}</b>
              <ul>
                <li v-for="option in voyage.options" :key="option.key">{{ option.title }}</li>
              </ul>
            </div>
          </div>
          <LangRouterLink :to="{ name: 'soumission' }" class="button -right voyage-aside__button">
            {{ $t('trip.quote') }}
            <div class="button__icon">
              <Icon id="arrow" />
            </div>
          </LangRouterLink>
        </aside>
      </section>
    </div>

    <section class="section -h-pad -less-pad" v-if="voyage.itinerary?.length">
      <div>
        <h2 class="voyage-itinerary__title">{{ $t('trip.itinerary') }}</h2>
        <div class="voyage-itinerary">
          <div class="voyage-itinerary__card" v-for="(item, key) in voyage.itinerary" :key="key">
            <div
              class="voyage-itinerary__card-image"
              :style="{
                backgroundImage: `url(${item.image?.md || 'https://placehold.co/400x200'})`,
              }"
            />
            <div class="voyage-itinerary__card-content">
              <h3 class="voyage-itinerary__card-title">{{ item.title }}</h3>
              <div v-html="item.description" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <SectionSwiperMedias :medias="voyage.medias || []" v-if="voyage.medias?.length" />

    <PageBuilder v-if="voyage.sections?.length" :sections="voyage.sections" />

    <SectionSwiperVoyages
      :destinations="others"
      :title="$t('trip.othersTitle')"
      :description="$t('trip.othersDescription')"
      :explore-btn="$t('trip.othersMore')"
    />
  </template>

  <template v-else>
    <Loader />
  </template>
</template>

<script>
import Loader from '@/components/blocks/Loader.vue'
import SectionSwiperMedias from '@/components/blocks/SectionSwiperMedias.vue'
import Icon from '@/components/global/Icon.vue'
import LangRouterLink from '@/components/global/LangRouterLink.vue'
import PageBuilder from '@/components/PageBuilder.vue'
import AdBanner from '@/components/sections/AdBanner.vue'
import SectionSwiperVoyages from '@/components/sections/SectionSwiperVoyages.vue'
import { setMeta } from '@/helpers/metaHelpers'

export default {
  name: 'Voyage',
  components: {
    AdBanner,
    Icon,
    LangRouterLink,
    Loader,
    PageBuilder,
    SectionSwiperMedias,
    SectionSwiperVoyages,
  },
  watch: {
    voyage: {
      handler(to) {
        if (to) setMeta(to.seo)
      },
      immediate: true,
    },
  },
  mounted() {
    if (!this.voyage) this.$router.replace({ name: 'not-found' })
  },
  computed: {
    ads() {
      if (!this.voyage) return []

      return this.$beet?.ads?.destinations?.[this.voyage.id] ?? []
    },
    others() {
      if (!this.$beet.destinations || null) return null

      return Object.values(this.$beet.destinations || null)
        .toSorted(() => Math.random() - 0.5)
        .filter(({ slug }) => slug !== this.$route.params.slug)
        .slice(0, 6)
        .map(({ id }) => id)
    },
    voyage() {
      if (!this.$beet.destinations) return null
      return Object.values(this.$beet.destinations).find(
        ({ slug }) => slug === this.$route.params.slug,
      )
    },
  },
}
</script>
